import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { getLatestNews } from "../../api/news";
import { useLanguage } from "../../context/LanguageContext";

const INDIA_SAFFRON = "#FF9933";
const INDIA_GREEN = "#138808";
const INDIA_BLUE = "#000080";

const LatestUpdates = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const [news, setNews] = useState([]);

  useEffect(() => {
    fetchNews();
  }, [language]);

  const fetchNews = async () => {
    try {
      const data = await getLatestNews(language);
      console.log("data__", data);

      setNews(data);
    } catch (err) {
      console.error("News API error:", err);
    }
  };

  return (
    <Box sx={{ px: { xs: 2, md: 4 }, py: 6 }}>
      <Box sx={{ textAlign: "center", mb: { xs: 3, sm: 4, md: 5 } }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.75rem" },
            color: "#1e293b",
            position: "relative",
            display: "inline-block",
            "&:after": {
              content: '""',
              position: "absolute",
              bottom: -8,
              left: "50%",
              transform: "translateX(-50%)",
              width: { xs: 60, sm: 80 },
              height: 3,
              background: `linear-gradient(90deg, ${INDIA_SAFFRON}, ${INDIA_GREEN})`,
              borderRadius: 2,
            }
          }}
        >
          {language === "mr" ? "ताज्या घडामोडी" : "Latest Updates"}
        </Typography>
      </Box>
      {/* <Typography variant="h5" fontWeight={700} mb={4} sx={{
        textAlign: "center",
        width: "100%",
      }}>
        {language === "mr" ? "ताज्या घडामोडी" : "Latest Updates"}
      </Typography> */}

      <Grid container spacing={3}>
        {news.slice(0, 2).map((item) => (
          <Grid item xs={12} md={6} key={item.id}>
            <Card variant="outlined" sx={{ height: "100%" }}>
              <CardContent>
                <Typography variant="h6" fontWeight={600}>
                  {item.title}
                </Typography>

                <Typography color="text.secondary" mb={2}>
                  {new Date(item.date).toLocaleDateString(
                    language === "mr" ? "mr-IN" : "en-IN",
                    {
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    }
                  )}
                </Typography>

                <Typography mb={2}>
                  {item.shortDesc}
                </Typography>

                <Button
                  size="small"
                  onClick={() => navigate(`/news/${item.slug}`)}
                >
                  {language === "mr" ? "अधिक वाचा →" : "Read more →"}
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default LatestUpdates;
